<div [ngStyle]="{ 'display' : this.selfTrainingToolService.active? 'block' : 'none'}" [ngClass]="tabsService.minimizeScreenMode ? 'bottom-menu minimized' : ''">
  <div class="loading" [ngClass]="this.selfTrainingToolService.loading? 'active' : ''">
    <div></div>
  </div>
    <div class="fields__block" style="width: 100%;">
      <div class="fields__block__section">
        <div class="title"><h4>List of training exercices</h4></div>

        <div class="table-fields">


          <div style="width: 100%; margin: 0 auto; overflow: hidden;overflow-x: scroll;">
            <table style="width: 100%;">
              <thead>
                <tr>
                  <th scope="col" style="min-width: 200px;width: 300px;">Title</th>
                  <th scope="col" style="min-width: 200px;">Comments</th>
                  <th scope="col" style="min-width: 130px; width: 130px;">Link</th>
                  <th scope="col" style="width: 50px;">Done</th>
                </tr>
              </thead>
              <tbody style="max-height: 325px; overflow-y: auto;">
                <tr mdbTableCol *ngFor="let ex of this.selfTrainingToolService.exerciseList; let i = index">
                    <td style="min-width: 200px;width: 300px;" class="bold">{{ex.title}}</td>
                    <td style="min-width: 200px;">
                      <input id="txt_{{i}}" name="txt_{{i}}" type="text" [(ngModel)]="ex.comments"/>
                    </td>
                    <td style="min-width: 130px; width: 130px;">
                      <a target="_blank" class="external-link" href="{{ex.linkToPage}}">Open exercice</a>
                    </td>
                    <td style="width: 50px;">
                      <input id="chk_{{i}}" name="chk_{{i}}" type="checkbox" [(ngModel)]="ex.done"/>
                    </td>
                </tr>
              </tbody>
            </table>
          </div>



          <div style="width: 100%; margin: 0 auto; overflow: hidden;overflow-x: scroll;display:none;">
            <table style="width: 100%;">
              <thead>
                <tr>
                  <th scope="col" style="min-width: 200px;width: 300px;">Title</th>
                  <th scope="col" style="min-width: 200px;">Comments</th>
                  <th scope="col" style="min-width: 130px; width: 130px;">Link</th>
                  <th scope="col" style="width: 150px;">Progress %</th>
                </tr>
              </thead>
              <tbody style="max-height: 325px; overflow-y: auto;">
                <tr mdbTableCol *ngFor="let ex of this.selfTrainingToolService.exerciseList; let i = index">
                    <td style="min-width: 200px;width: 300px;" class="bold">{{ex.title}}</td>
                    <td style="min-width: 200px;">
                      <input id="txt_{{i}}" name="txt_{{i}}" type="text" [(ngModel)]="ex.comments"/>
                    </td>
                    <td style="min-width: 130px; width: 130px;">
                      <a target="_blank" class="external-link" href="{{ex.linkToPage}}">Open exercice</a>
                    </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div class="fields__btn">
      <button type="submit" [ngClass]="checkIfChanges() ? 'blue' : 'gray'" [disabled]="!checkIfChanges()" (click)="saveState()">
        Save
      </button>
      <button [ngClass]="checkIfZeroState() ? 'gray' : 'blue'" [disabled]="checkIfZeroState()" (click)="resetState()">Reset</button>
    </div>
  </div>